import styled, { css } from 'styled-components';

const Divider = styled.div<{
	$direction: 'H' | 'V';
	$color?: string;
	$transition?: boolean;
}>`
	${(props) =>
		props.$direction === 'H' &&
		css`
			width: 100%;
			height: 1px;
		`}

	${(props) =>
		props.$direction === 'V' &&
		css`
			width: 1px;
			height: 100%;
		`}
	
	background-color: ${(props) => props.$color || '#ffffff'};
	${(props) =>
		props.$transition &&
		css`
			transition:
				background-color 0.3s ease,
				opacity 0.3s ease;
		`}
`;

export { Divider };
